import {
  Component,
  ElementRef,
  ViewChild,
  signal,
  OnInit,
  AfterViewInit,
  inject,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ValidationConstant } from '../../../../../constants/validation.constant';
import {
  NgbAccordionConfig,
  NgbAccordionModule,
  NgbActiveModal,
  NgbCollapseModule,
} from '@ng-bootstrap/ng-bootstrap';
import { AllyCommonService } from '../../../../../services/ally-common-service';
import { UserService } from '../../../../../services/user-service';
import { CommonService, Exception, ToasterService, Validator } from '@anddone/ui-utilities';
import { AppSetting } from '../../../../../constants/appsetting.constant';
import { TranslateModule } from '@ngx-translate/core';
import { NgStyle } from '@angular/common';
import { UserAuthenticationType } from '../../../../../enum/UserAuthenticationType.enum';
import { UserTypeEnum } from '../../../../../enum/user-type.enum';
import { MessageConstants } from '../../../../../constants/message.constant';
import intlTelInput from 'intl-tel-input';

@Component({
  selector: 'app-add-user',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgbAccordionModule,
    NgStyle,
    TranslateModule,
    NgbCollapseModule,
  ],
  templateUrl: './add-user.html',
  styleUrl: './add-user.scss',
  providers: [provideNgxMask()],
})
export class AddUser implements OnInit, AfterViewInit {
  @ViewChild('inputPhone', { static: false }) inputPhone!: ElementRef;
  // Form variables
  addUserForm: any;
  addUserFormErrors: any = {};
  validator: Validator;

  // Loaders
  isLoader_AddUser = signal<boolean>(false);

  // Other
  loggedInUserData: any;
  countryList: any;
  stateList: any;
  countryId: any;
  postalCodeMask: any = '00000-0000';
  postalCodeMinLength = 5;

  config = {
    FirstName: {
      required: { name: ValidationConstant.user.add.firstName.name },
      maxlength: {
        name: ValidationConstant.user.add.firstName.name,
        max: ValidationConstant.user.add.firstName.maxLength.toString(),
      },
      minlength: {
        name: ValidationConstant.user.add.firstName.name,
        min: ValidationConstant.user.add.firstName.minLength.toString(),
      },
      pattern: { name: ValidationConstant.user.add.firstName.name },
    },
    LastName: {
      required: { name: ValidationConstant.user.add.lastName.name },
      maxlength: {
        name: ValidationConstant.user.add.lastName.name,
        max: ValidationConstant.user.add.lastName.maxLength.toString(),
      },
      minlength: {
        name: ValidationConstant.user.add.lastName.name,
        min: ValidationConstant.user.add.lastName.minLength.toString(),
      },
      pattern: { name: ValidationConstant.user.add.lastName.name },
    },
    Username: {
      required: { name: ValidationConstant.user.add.userName.name },
      maxlength: {
        name: ValidationConstant.user.add.userName.name,
        max: ValidationConstant.user.add.userName.maxLength.toString(),
      },
      usernameWithAtleastoneletter: {
        name: ValidationConstant.user.add.userName.name,
        min: ValidationConstant.user.add.userName.minLength.toString(),
      },
    },
    Phone: {
      required: { name: ValidationConstant.user.add.phone.name },
      maxlength: {
        name: ValidationConstant.user.add.phone.name,
        max: ValidationConstant.user.add.phone.mask_maxLength.toString(),
      },
      minlength: {
        name: ValidationConstant.user.add.phone.name,
        min: ValidationConstant.user.add.phone.mask_minLength.toString(),
      },
      pattern: { name: ValidationConstant.user.add.phone.name },
    },
    Email: {
      required: { name: ValidationConstant.user.add.email.name },
      maxlength: {
        name: ValidationConstant.user.add.email.name,
        max: ValidationConstant.user.add.email.maxLength.toString(),
      },
      minlength: {
        name: ValidationConstant.user.add.email.name,
        min: ValidationConstant.user.add.email.minLength.toString(),
      },
      pattern: { name: ValidationConstant.user.add.email.name },
    },
    AddressLine1: {
      required: { name: ValidationConstant.user.add.addressLine1.name },
      maxlength: {
        name: ValidationConstant.user.add.addressLine1.name,
        max: ValidationConstant.user.add.addressLine1.maxLength.toString(),
      },
      minlength: {
        name: ValidationConstant.user.add.addressLine1.name,
        min: ValidationConstant.user.add.addressLine1.minLength.toString(),
      },
      pattern: { name: ValidationConstant.user.add.addressLine1.name },
    },
    AddressLine2: {
      required: { name: ValidationConstant.user.add.addressLine2.name },
      maxlength: {
        name: ValidationConstant.user.add.addressLine2.name,
        max: ValidationConstant.user.add.addressLine2.maxLength.toString(),
      },
      minlength: {
        name: ValidationConstant.user.add.addressLine2.name,
        min: ValidationConstant.user.add.addressLine2.minLength.toString(),
      },
      pattern: { name: ValidationConstant.user.add.addressLine2.name },
    },
    City: {
      required: { name: ValidationConstant.user.add.city.name },
      maxlength: {
        name: ValidationConstant.user.add.city.name,
        max: ValidationConstant.user.add.city.maxLength.toString(),
      },
      minlength: {
        name: ValidationConstant.user.add.city.name,
        min: ValidationConstant.user.add.city.minLength.toString(),
      },
      pattern: { name: ValidationConstant.user.add.city.name },
    },
    State: {
      required: { name: ValidationConstant.user.add.state.name },
    },
    Country: {
      required: { name: ValidationConstant.user.add.country.name },
    },
    PostalCode: {
      required: { name: ValidationConstant.user.add.postalCode.name },
      maxlength: {
        name: ValidationConstant.user.add.postalCode.name,
        max: ValidationConstant.user.add.postalCode.mask_maxLength.toString(),
      },
      minlength: {
        name: ValidationConstant.user.add.postalCode.name,
        min: ValidationConstant.user.add.postalCode.mask_minLength.toString(),
      },
      pattern: { name: ValidationConstant.user.add.postalCode.name },
    },
  };
  selectedCountryCode!: string;
  public activeModal = inject(NgbActiveModal);
  private formBuilder = inject(FormBuilder);
  private allyCommonService = inject(AllyCommonService);
  private commonService = inject(CommonService);
  public userService = inject(UserService); // to use in test cases
  public toasterService = inject(ToasterService); // to use in test cases
  Accordionconfig = inject(NgbAccordionConfig);
  constructor() {
    this.validator = new Validator(this.config);
    this.Accordionconfig.closeOthers = false;
    // Accordionconfig.type = 'info';
  }

  ngOnInit(): void {
    this.loggedInUserData = this.allyCommonService.getLoggedInData() || '';
    this.countryList = this.allyCommonService.getCountryList() || [];
    this.stateList = this.allyCommonService.getStateList() || [];
    this.addUserForm = this.formBuilder.group({
      FirstName: [
        '',
        [
          Validators.required,
          Validators.maxLength(ValidationConstant.user.add.firstName.maxLength),
          Validators.pattern(ValidationConstant.firstNameLastName_regex),
        ],
      ],
      LastName: [
        '',
        [
          Validators.required,
          Validators.maxLength(ValidationConstant.user.add.lastName.maxLength),
          Validators.pattern(ValidationConstant.firstNameLastName_regex),
        ],
      ],
      Username: [
        '',
        [
          Validators.required,
          Validators.maxLength(ValidationConstant.user.add.userName.maxLength),
          Validators.minLength(ValidationConstant.user.add.userName.minLength),
          this.customPatternValidator(ValidationConstant.alphanumeric_numeric_atleast_one_letter),
        ],
      ],
      Phone: [
        '',
        [
          Validators.required,
          Validators.maxLength(ValidationConstant.user.add.phone.maxLength),
          Validators.minLength(ValidationConstant.user.add.phone.minLength),
          Validators.pattern(ValidationConstant.phoneFormat_regex),
        ],
      ],
      Email: [
        '',
        [
          Validators.required,
          Validators.maxLength(ValidationConstant.user.add.email.maxLength),
          Validators.pattern(ValidationConstant.email_regex),
        ],
      ],
      BasicAuth: [],
      APIKey: [],
      isAdmin: [true, []],
      address: this.initAddress(),
    });
    this.addUserForm.valueChanges.subscribe((_data: any) => this.onValueChanged('addUserForm'));
    this.addUserForm
      .get('address')
      .get('Country')
      .valueChanges.subscribe((countryId: any) => {
        this.countryId = countryId;
        this.addValidationPostalCode(countryId);
        this.stateList = this.commonService.getMappedState(countryId);

        this.addUserForm.get('address').get('State').patchValue('');
      });
  }

  addUser() {
    if (!this.addUserForm.value.BasicAuth && !this.addUserForm.value.APIKey) {
      this.toasterService.showError(MessageConstants.user.selectAuthenticationTypeError, 'full');
      return;
    }
    this.validator.validateAllFormFields(this.addUserForm);
    this.addUserFormErrors = this.validator.validate(this.addUserForm);
    if (this.addUserForm.invalid) {
      return;
    }
    this.isLoader_AddUser.set(true);
    const reqObj: any = {};
    reqObj.parentId = this.loggedInUserData?.id;
    reqObj.userName = this.addUserForm.value.Username;
    reqObj.userType = this.loggedInUserData?.userType;
    reqObj.isAdmin = true; //this.addUserForm.value.isAdmin;
    reqObj.userType = UserTypeEnum.ALLY;
    reqObj.contact = {
      name: {
        firstName: this.addUserForm.value.FirstName,
        lastName: this.addUserForm.value.LastName,
      },
      phone: this.addUserForm.value.Phone.split('-').join(''),
      email: this.addUserForm.value.Email,
      address: this.createAddressObject(),
      isdCode: `+${this.selectedCountryCode}`,
    };
    if (this.selectedCountryCode == undefined) {
      reqObj.contact.isdCode = '';
    }
    if (this.addUserForm.value.BasicAuth && this.addUserForm.value.APIKey) {
      reqObj.userAuthenticationType = UserAuthenticationType.BearerAndAPI; // Basic Auth & API Key
    } else if (this.addUserForm.value.BasicAuth) {
      reqObj.userAuthenticationType = UserAuthenticationType.BearerOnly; // Basic Auth
    } else if (this.addUserForm.value.APIKey) {
      reqObj.userAuthenticationType = UserAuthenticationType.APIOnly; // API Key
    }
    this.userService.addUser(reqObj, this.loggedInUserData?.id).subscribe({
      next: (_res: any) => {
        this.addUserForm.reset();
        this.isLoader_AddUser.set(false);
        this.toasterService.showSuccess(MessageConstants.user.adduserSuccess, 'full');
        this.userService.updateAddUserStatus(true);
        this.close();
      },
      error: (e) => {
        this.isLoader_AddUser.set(false);
        const toastMessage = Exception.exceptionMessage(e);
        this.toasterService.showError(toastMessage.join(', '), 'full');
      },
    });
  }

  createAddressObject() {
    const addressData = this.addUserForm.get('address').controls;

    const address: any = {
      addressLine1: addressData.AddressLine1.value || null,
      addressLine2: addressData.AddressLine2.value || null,
      city: addressData.City.value || null,
      postalCode: addressData.PostalCode.value || null,
    };

    const hasAddressData = Object.values(address).some((value) => !!value);

    return hasAddressData
      ? {
          ...address,
          state: addressData.State.value,
          country: addressData.Country.value,
        }
      : null;
  }

  close() {
    this.activeModal.close('Modal closed');
  }

  validatePostalCode(event: any) {
    if (this.addUserForm.controls.address.controls.Country.value == '1') {
      this.postalCodeMask = '00000-0000';
      if (event?.target?.value.indexOf('-') != -1 && event?.target?.value.length != 10) {
        this.postalCodeMinLength = 9;
        this.addUserForm.controls.address.controls.PostalCode?.addValidators([
          Validators.minLength(9),
        ]);
        this.addUserForm.controls.address.controls.PostalCode?.updateValueAndValidity();
        this.config.PostalCode.minlength.min = this.postalCodeMinLength.toString();
        this.validator = new Validator(this.config);
        this.validator.validateAllFormFields(this.addUserForm);
        this.addUserFormErrors = this.validator.validate(this.addUserForm);
        return;
      } else if (event.target?.value.indexOf('-') == -1 && event.target?.value.length < 5) {
        this.postalCodeMinLength = 5;
        this.addUserForm.controls.address.controls.PostalCode?.addValidators([
          Validators.minLength(5),
        ]);
        this.addUserForm.controls.address.controls.PostalCode?.updateValueAndValidity();
        this.config.PostalCode.minlength.min = this.postalCodeMinLength.toString();
        this.validator = new Validator(this.config);
        this.validator.validateAllFormFields(this.addUserForm);
        this.addUserFormErrors = this.validator.validate(this.addUserForm);

        return;
      } else {
        this.addUserForm.controls.address.controls.PostalCode?.clearValidators();
        this.addUserForm.controls.address.controls.PostalCode?.updateValueAndValidity();
      }
    } else if (this.addUserForm.controls.address.controls.Country.value == '2') {
      this.postalCodeMask = 'S0S 0S0';
      this.postalCodeMinLength = 6;
      this.addUserForm.controls.address.controls.PostalCode?.addValidators([
        Validators.minLength(this.postalCodeMinLength),
      ]);
      this.addUserForm.controls.address.controls.PostalCode?.updateValueAndValidity();
      this.config.PostalCode.minlength.min = this.postalCodeMinLength.toString();
      this.validator = new Validator(this.config);
      this.validator.validateAllFormFields(this.addUserForm);
      this.addUserFormErrors = this.validator.validate(this.addUserForm);
    } else {
      this.postalCodeMask = '';
    }

    if (event.target?.value.length == 0) {
      this.addUserForm.controls.address.controls.PostalCode?.clearValidators();
      this.addUserForm.controls.address.controls.PostalCode?.updateValueAndValidity();
    }
  }

  checkAuthenticationType() {
    setTimeout(() => {
      if (this.addUserForm.value.BasicAuth) {
        this.addUserForm
          .get('FirstName')
          .setValidators([
            Validators.required,
            Validators.maxLength(ValidationConstant.user.add.firstName.maxLength),
            Validators.pattern(ValidationConstant.firstNameLastName_regex),
          ]);
        this.addUserForm
          .get('LastName')
          .setValidators([
            Validators.required,
            Validators.maxLength(ValidationConstant.user.add.lastName.maxLength),
            Validators.pattern(ValidationConstant.firstNameLastName_regex),
          ]);
        this.addUserForm
          .get('Phone')
          .setValidators([
            Validators.required,
            Validators.maxLength(ValidationConstant.user.add.phone.maxLength),
            Validators.minLength(ValidationConstant.user.add.phone.minLength),
            Validators.pattern(ValidationConstant.phoneFormat_regex),
          ]);
        this.addUserForm.get('FirstName').updateValueAndValidity();
        this.addUserForm.get('LastName').updateValueAndValidity();
        this.addUserForm.get('Phone').updateValueAndValidity();
      } else {
        this.addUserForm.get('FirstName').setValidators(null);
        this.addUserForm.get('LastName').setValidators(null);
        this.addUserForm.get('Phone').setValidators(null);
        this.addUserForm.get('FirstName').updateValueAndValidity();
        this.addUserForm.get('LastName').updateValueAndValidity();
        this.addUserForm.get('Phone').updateValueAndValidity();
      }
    }, 1000);
  }

  onInput(event: Event): void {
    // Remove non-numeric characters
    const inputValue = (event.target as HTMLInputElement).value.replace(/\D/g, '');
    this.addUserForm.controls.Phone.patchValue(inputValue);
  }

  customPatternValidator(pattern: RegExp): ValidatorFn {
    return (control: AbstractControl): Record<string, any> | null => {
      const valid = pattern.test(control.value);
      if (!valid && control.value !== '') {
        return { usernameWithAtleastoneletter: { value: control.value } };
      }
      return null;
    };
  }

  initAddress() {
    return this.formBuilder.group({
      AddressLine1: [
        '',
        [
          Validators.maxLength(ValidationConstant.user.add.addressLine1.maxLength),
          Validators.pattern(ValidationConstant.alphanumericWithSpaceAndSomeSpecialChar_regex),
        ],
      ],
      AddressLine2: [
        '',
        [
          Validators.maxLength(ValidationConstant.user.add.addressLine2.maxLength),
          Validators.pattern(ValidationConstant.alphanumericWithSpaceAndSomeSpecialChar_regex),
        ],
      ],
      City: [
        '',
        [
          Validators.maxLength(ValidationConstant.user.add.city.maxLength),
          Validators.pattern(ValidationConstant.charactersOnlyWithSpace_regex),
        ],
      ],
      State: ['', []],
      Country: [AppSetting.defaultCountry, []],
      PostalCode: [
        '',
        [
          Validators.maxLength(ValidationConstant.user.add.postalCode.maxLength),
          Validators.minLength(ValidationConstant.user.add.postalCode.minLength),
        ],
      ],
    });
  }

  addValidationPostalCode(countryId: any) {
    this.addUserForm.get('address').get('PostalCode').patchValue('');
    this.addUserForm.controls.address.controls.PostalCode?.clearValidators();
    this.addUserForm.controls.address.controls.PostalCode?.updateValueAndValidity();
    this.addUserForm.controls.address.controls.postalCode?.reset();
    if (countryId == 2) {
      this.postalCodeMask = 'S0S 0S0';
    } else {
      this.postalCodeMask = '00000-0000';
    }
  }

  onValueChanged(data?: any) {
    if (data === 'addUserForm') {
      if (!this.addUserForm) {
        return;
      }
      this.addUserFormErrors = this.validator.validate(this.addUserForm);
    }
  }

  omit_numeric_special_char(event: any) {
    const k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      k == 45 ||
      k == 44 ||
      k == 46 ||
      k == 39 ||
      k == 96
    );
  }

  ngAfterViewInit() {
    const inputPhone = this.inputPhone?.nativeElement;
    if (inputPhone) {
      const iti = intlTelInput(inputPhone, {
        initialCountry: 'us',
        separateDialCode: true,
        // utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js",
      });
      this.selectedCountryCode = iti.getSelectedCountryData().dialCode;

      inputPhone.addEventListener('countrychange', () => {
        iti.setNumber('');
        this.selectedCountryCode = iti.getSelectedCountryData().dialCode;
      });
    }
  }
}
